<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<!--<span  class="focusable-element"></span>-->
<div class="row">
    <div class="col-16">
        <h1 tabindex="1000" class="medium">Single Enrollment </h1>
        <br />
    </div>
</div>
<div class="row" *ngIf="hasError" aria-live="polite" tabindex="0" role="alert">
    <div class="col-24">
        <div class="alert danger">
            <p><em>Error Message:</em></p>
            <ul>
                <li *ngFor="let error of ErrorMessages" aria-atomic="true">
                    {{error}}
                </li>
            </ul>
        </div>
    </div>
</div>
<div class="row" *ngIf="IsErrorMesssage" aria-live="polite" tabindex="0" role="alert" #focusableEleTop>
    <div class="col-24">
        <div class="alert danger">
            <p><em>Error Message:</em></p>
            <ul>
                <li *ngFor="let error of errorMessage" aria-atomic="true">{{error}}</li>
            </ul>
        </div>
    </div>
</div>
<div class="row" *ngIf="EnrollmentMethodError || SOAError">
    <div class="col-24">
        <div class="alert danger">
            <p><em>Error Message:</em></p>
            <ul>
                <li *ngIf="EnrollmentMethodError">
                    <button>
                        Please select a Enrollment Method.
                    </button>
                </li>
                <li *ngIf="SOAError">
                    <button>
                        Please select a Scope of Appointment.
                    </button>
                </li>
            </ul>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-8">
        <div class="input-wrapper">
            <ValidatedTextField [label]="'Agent ID for this enrollment:'"
                                [text]="agentUserName"
                                (onValueChange)="dataEntryStep1.AgentName = $event"
                                [validators]="[notBlankValidator]"
                                [disabled]="isValidAgent" 
                                [for]="AgentID">
            </ValidatedTextField>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-24">
        <div *ngIf="!isValidAgent">
            <button class="button primary" (click)="onContinue()">Continue</button>
        </div>
        <div *ngIf="isValidAgent">
            <button class="button primary" (click)="onChangeAgentID()">Change Agent ID</button>
        </div>
    </div>
</div>
<div *ngIf="isValidAgent">
    <div class="row">
        <div class="col-8">
            <div class="bottom-20">
                <ValidatedDropDown class="wide"
                                   [for]="'ApplicantState'"
                                   [selectedValue]="planstate"
                                   [label]="'Select the applicant’s state:'"
                                   [disabled]="disabled"
                                   (onValueChange)="planstate = $event"
                                   [options]="states">
                </ValidatedDropDown>
            </div>
        </div>
    </div>
    <div >
        <div class="row">
            <div class="col-8">
                <div class="bottom-20">
                    <!--<ValidatedDateTextField [label]="'Date of Receipt:'"
                                        id="dateofReceipt "
                                        [date]="dataEntryStep1.DateofReceipt"
                                        (onDateChange)="dataEntryStep1.DateofReceipt = $event"
                                        [validators]="[validatedDate,notBlankValidator]">
                </ValidatedDateTextField>-->
                    <JQDatePicker [for]="DateOfReceipt" [label]="'Date of Receipt:'"
                                  [selectedDate]="dataEntryStep1.DateofReceipt"
                                  (elementClicked)="dataEntryStep1.DateofReceipt = $event" id="DateofReceipt">
                    </JQDatePicker>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="bottom-20">
                    <ValidatedRadioButtonGroup [label]="'Select Enrollment Type:'"
                                               [options]="optionrbConactType"
                                               [selectedValue]="selFaxContactType"
                                               (onValueChange)="dataEntryStep1.DataSource = $event"
                                               [radioGroupName]="'ContactType'">
                    </ValidatedRadioButtonGroup>
                </div>
            </div>
        </div>
        
    </div>
    <div class="row">
        <div class="col-24">
            <button class="button primary" (click)="formSubmit()">Submit</button>
        </div>
    </div>
</div>
